import React from "react";
import ReactDOM from "react-dom/client";
import { GrowthBookProvider } from "@growthbook/growthbook-react";
import MainApp from "./MainApp";
import { growthbook } from "./lib/growthbook";
import "./assets/styles/globals.css";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
);

async function bootstrap() {
    await growthbook.init({ timeout: 2000 });

    root.render(
        <React.StrictMode>
            <GrowthBookProvider growthbook={growthbook}>
                <MainApp />
            </GrowthBookProvider>
        </React.StrictMode>
    );
}

bootstrap();